/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Export_Export_Preset_SavedInputs */

const en_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video export preset "${i?.name}" saved successfully`)
};

const fr_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prereglage d'exportation video "${i?.name}" enregistre avec succes`)
};

const de_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Videoexportvorgabe "${i?.name}" erfolgreich gespeichert`)
};

const it_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione di esportazione video "${i?.name}" salvata correttamente`)
};

const ru_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Настройки экспорта видео "${i?.name}" успешно сохранены.`)
};

const es_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El ajuste preestablecido de exportación de video "${i?.name}" se guardó correctamente`)
};

const zh_cn2_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`视频导出预设“${i?.name}”已成功保存`)
};

const ja_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオエクスポートプリセット「${i?.name}」が正常に保存されました`)
};

const hi_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रीसेट "${i?.name}" सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_video_export_export_preset_saved = /** @type {(inputs: Video_Export_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A predefinição de exportação de vídeo "${i?.name}" foi salva com sucesso.`)
};

/**
* | output |
* | --- |
* | "Video export preset \"{name}\" saved successfully" |
*
* @param {Video_Export_Export_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_saved = /** @type {((inputs: Video_Export_Export_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_preset_saved(inputs)
	if (locale === "de") return de_video_export_export_preset_saved(inputs)
	if (locale === "it") return it_video_export_export_preset_saved(inputs)
	if (locale === "ru") return ru_video_export_export_preset_saved(inputs)
	if (locale === "es") return es_video_export_export_preset_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_preset_saved(inputs)
	if (locale === "ja") return ja_video_export_export_preset_saved(inputs)
	if (locale === "hi") return hi_video_export_export_preset_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_preset_saved(inputs)
	return en_video_export_export_preset_saved(inputs)
});